import { t } from '@lingui/macro';
import { BankDto } from '~/types/internal-api';

export const validator = {
    bankName: (value: string, banks: BankDto[]) => {
        if (!value || !banks.some(item => item.name === value)) {
            return t`Bank must be completed.`;
        }
    },
    danishBankRegistrationNumber: value => {
        const regex = /(^\d{4}$)/;
        const notRequiredLength = !regex.test(value);

        if (!value || notRequiredLength || value === 0) {
            return t`Sort code has to be 4 digits.`;
        }
        if (isNaN(value)) {
            return t`Sort code can only contain numbers.`;
        }
    },
    bankRegistrationNumber: value => {
        if (value.length > 10) {
            return t`Sort code is too long.`;
        }
        if (isNaN(value)) {
            return t`Sort code can only contain numbers.`;
        }
    },
    danishBankAccountNumber: value => {
        const regex = /(^\d{7}$)|(^\d{10}$)/;
        const notRequiredLength = !regex.test(value);

        if (!value || notRequiredLength || value === 0) {
            return t`Account no. has to be 7 or 10 digits.`;
        }
        if (isNaN(value)) {
            return t`Account no. can only contain numbers.`;
        }
    },
    bankAccountNumber: value => {
        if (value.length > 50) {
            return t`Account no. is too long.`;
        }
        if (isNaN(value)) {
            return t`Account no. can only contain numbers.`;
        }
    },
    iban: value => {
        if (value && value.length > 50) {
            return t`IBAN no. is too long.`;
        }
    },
    pbsNo: value => {
        if (value && value.length > 20) {
            return t`PBS no. is too long.`;
        }
    },
    pbsCustGrNo: value => {
        const maxInt = 2147483647;

        if (value) {
            if (value > maxInt) {
                return t`PBS cust. gr. no. is too long.`;
            }
            if (isNaN(value)) {
                return t`PBS cust. gr. no. can only contain numbers.`;
            }
        }
    },
    giroAccount: value => {
        if (value && value.length > 20) {
            return t`Giro account is too long.`;
        }
    },
    fiSupplierNo: value => {
        if (value && value.length > 8) {
            return t`FI supplier no. is too long.`;
        }
    },
    number: value => {
        if (!value) {
            return t`Account from CoA must be completed.`;
        }
    },
    note: value => {
        if (value && value.length > 400) {
            return t`Note is too long.`;
        }
    },
};
